import React, { useContext, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useComponentHeight, Watermark } from '@mummssoftware/common-ui';
import { AppContext } from '../App/AppContext';
import { MedContext } from '../App/MedContext';
import { SET_DIMENSIONS } from '../App/constants';

// TODO improve ActionTopBar Widget
const ActionTopBar = styled.div`
  ${(props) => (props.embedded ? '' : css``)}
  ${(props) => (props.hideActionBar ? 'display: none;' : '')}
  ${(props) =>
    props.dashboardEmbedded
      ? `border-right: 14px solid ${props.theme.palette.background.paper};`
      : ''}
  width: 100%;
  min-width: ${(props) => `${props.dashboardEmbedded ? '' : '750px'}`};
  z-index: 100;
  overflow: hidden;
  background-color: ${(props) => `${props.theme.props.header.background}`};
  @media print {
    display: none;
  }
`;

const FilterTopBar = styled.div`
  width: 100%;
  min-width: ${(props) => `${props.dashboardEmbedded ? '' : '750px'}`};
  min-height: 55px;
  overflow: visible;
  background-color: ${(props) => `${props.theme.palette.background.light1}`};
  ${(props) => `${props.dashboardEmbedded ? mobileDashBreakPoints : null}`}
  @media print {
    display: none;
  }
`;

const mobileDashBreakPoints = css`
  @media screen and (max-device-width: 602px) {
    height: 105px;
  }
  @media screen and (max-device-width: 490px) {
    height: 145px;
  }
  @media screen and (max-device-width: 313px) {
    height: 190px;
  }
`;

const ContentWrapper = styled.div`
  ${(props) =>
    props.embedded
      ? 'position: relative;'
      : css`
          margin-top: ${props.height}px;
          height: calc(100vh - ${props.height}px);
        `}
  @media print {
    overflow: visible;
    height: auto;
    margin: 0;
  }
`;

const MedicationContainer = styled.div`
  ${(props) => `${props.dashboardEmbedded ? ';' : 'min-width: 750px'}`}
  list-style-type: 'none';
  && {
    overflow: visible;
  }
  && > div:last-child > div {
    border-bottom: none;
  }
  @media print {
    display: none;
  }
`;

const Body = ({
  TopBarContent,
  FilterBarContent,
  Medications,
  Dialog,
  PrintView,
  headerRef,
  embedded,
  dashboardEmbedded,
}) => {
  const height = useComponentHeight(headerRef);
  const actionBarRef = useRef(null);
  const filterBarRef = useRef(null);
  const { hideActionBar, watermark, smallWidget, readonly } = useContext(
    AppContext,
  );
  const { dispatch } = useContext(MedContext);
  const showActionBar = !smallWidget && !readonly;

  useEffect(() => {
    if (actionBarRef.current && showActionBar) {
      dispatch({
        type: SET_DIMENSIONS,
        payload:
          actionBarRef.current.offsetHeight + filterBarRef.current.offsetHeight,
      });
    }
  }, []);

  // todo ActionTopBar still useful?

  return (
    <ContentWrapper
      embedded={embedded}
      height={height}
      id="meds-content-wrapper"
    >
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <ActionTopBar
        embedded={embedded}
        hideActionBar={hideActionBar}
        dashboardEmbedded={dashboardEmbedded}
        ref={actionBarRef}
        id="actiontopbar"
      >
        {TopBarContent}
      </ActionTopBar>
      {showActionBar && (
        <FilterTopBar
          dashboardEmbedded={dashboardEmbedded}
          id="filtertopbar"
          ref={filterBarRef}
        >
          {FilterBarContent}
        </FilterTopBar>
      )}
      <MedicationContainer embedded={embedded}>
        {Medications}
      </MedicationContainer>
      {Dialog}
      {PrintView}
    </ContentWrapper>
  );
};

export default React.memo(Body);
